import { httpProvider }     from './httpProvider.config';
import locationProviderConfig from './locationProvider.config';
import stateProviderConfig    from './stateProvider.config';
import { modalProvider }      from './modalProvider.config';

const api = {
  "login"           : "/api/login",
  "logout"          : "/api/logout",
  "passwordResets"  : "/api/password-resets",
  "companies"       : "/api/companies",
  "bookings"        : "/api/bookings/",
  "users"           : "/api/users",
  "routes"          : "/api/routes",
  "vehicleBodies"   : "/api/vehicle-bodies",
  "operators"       : "/api/operators"
};

window.isDebugMode = location.hostname.indexOf('test') != -1 || location.hostname.indexOf('localhost') != -1;

if(window.isDebugMode){
  console.log( {
      'isChannelDebug': 'Set window.isChannelDebug to true for see all channel messages in console'
    } );
}

const ConfigsModule = angular
  .module('configs', [])
  .constant({
    "CONFIG": {
      "API"               : api,
      "ContentType"       : "application/json"
    }
  })
  .config( httpProvider )
  .config( locationProviderConfig )
  .config( stateProviderConfig )
  .config( modalProvider );

export default ConfigsModule;


/** WEBPACK FOOTER **
 ** ./frontend/config/config.js
 **/